import { Modal } from 'rsuite'
import dynamic from 'next/dynamic'
import styles from './videoModal.module.scss'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

const VideoModal = ({ show, close, url, title }) => (
  <Modal open={show} size="md" onClose={close} className={styles.overviewVideoModal}>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ReactPlayer
        src={url}
        controls
        width="100%"
        height="100%"
        playing={true}
        config={{
          youtube: {
            playerVars: { autoplay: 1 }
          }
        }}
      />
    </Modal.Body>
  </Modal>
)

export default VideoModal
